import React, { useEffect, useMemo, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

import Autocomplete from "@mui/material/Autocomplete";
import { Checkbox, Divider, Grid, Icon, InputAdornment, Stack, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MDButton from "components/MDButton";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ApiCalls from "services/flick_erp_api_call";
import { SelectHierarchicalEmployee } from "components/SelectHierarchicalEmployee";
import moment from "moment";
import SalesTable from "examples/Tables/SalesTable";
import { addTime } from "helpers/DateTime";
import { timeStringToHour } from "helpers/DateTime";
import {
  AccessTimeRounded,
  CheckCircleOutline,
  CheckCircleRounded,
  CrisisAlert,
  DownloadRounded,
  FingerprintSharp,
  FmdGoodOutlined,
  HomeWork,
  PhotoCameraOutlined,
  PunchClock,
  QueryBuilderRounded,
  Refresh,
  Search,
  TimerOutlined,
	WorkOff,
} from "@mui/icons-material";
import FormField from "layouts/applications/wizard/components/FormField";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";
import { getStoredUser } from "services";

// import DatePicker from "react-flatpickr";
function Attendance({ permissions, modulePermissions }) {
  const theme = useTheme();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const palette = theme.palette;
  const loggedUser = getStoredUser();
  const [searchValue, setSearchValue] = useState("");
	const [data, setData] = useState({});
  const [activeLogTab, setActiveLogTab] = useState("machine");
	const [activeEmployee, setActiveEmployee] = useState(loggedUser.employee_id);
  const [selectedMonth, setSelectedMonth] = useState(
    `${new Date().getFullYear()}-${new Date().toLocaleString("en-GB", {
      month: "2-digit",
    })}`
  );

  const [editAttendancePayload, setEditAttendancePayload] = useState({});

  const [selectedEmp, setSelectedEmp] = useState(
    JSON.parse(localStorage.getItem("user")).employee_id
  );
  const [inoutDialogOpen, setInoutDialog] = useState(false);
  const [editAttendanceDialogOpen, setEditAttendanceDialogOpen] =
    useState(false);
  const [missPunchDialogOpen, setMissPunchDialogOpen] = useState(false);
  const [missPunchDetailsPayload, setMissPunchDetailsPayload] = useState({});
  const [statusDialogOpen, setStatusDialog] = useState(false);
  const [SelectHierarchicalEmployeError, setSelectHierarchicalEmployeError] =
    useState("");
  const [mispunchCommentError, setMispunchCommentError] = useState("");
  const [inOutData, setInoutData] = useState([]);
  const [mobileAttendanceRows, setMobileAttendanceRows] = useState([]);
  const [mobileAttendanceMeta, setMobileAttendanceMeta] = useState({});
  const [mobileAttendanceDetail, setMobileAttendanceDetail] = useState(null);
  const [mobileAttendanceDialogOpen, setMobileAttendanceDialogOpen] = useState(false);
  const [selectedMobileDates, setSelectedMobileDates] = useState([]);
  const [isFilterRefreshing, setIsFilterRefreshing] = useState(false);
  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const ui = {
    page: darkMode ? palette.background.default : colors.white.main,
    card: darkMode ? palette.background.card : colors.white.main,
    soft: darkMode ? palette.background.muted : colors.background.elevated,
    softAlt: darkMode ? rgba(palette.white.main, 0.04) : colors.info.light,
    border: darkMode ? rgba(palette.white.main, 0.08) : rgba(colors.secondary.main, 0.08),
    title: darkMode ? palette.text.focus : colors.dark.main,
    body: darkMode ? palette.text.main : colors.secondary.main,
    iconSurface: darkMode ? rgba(palette.white.main, 0.06) : colors.background.elevated,
    statCard: darkMode ? palette.background.card : colors.white.main,
    dialogPaper: darkMode ? palette.background.card : colors.white.main,
    dialogBody: darkMode ? palette.background.muted : colors.white.main,
  };

  const getAttendanceImageCandidates = (value) => {
    if (!value) return [];
    if (typeof value !== "string") return [];
    if (value.startsWith("data:") || value.startsWith("blob:")) return [value];

    try {
      const parsedUrl = new URL(value, window.location.origin);
      const currentOrigin = window.location.origin;
      const candidates = [parsedUrl.toString()];

      if (parsedUrl.origin !== currentOrigin) {
        candidates.push(`${currentOrigin}${parsedUrl.pathname}${parsedUrl.search}`);
      }

      return [...new Set(candidates)];
    } catch (error) {
      return [value];
    }
  };

  const MobileImagePreview = ({ src, alt, height = 160 }) => {
    const candidates = getAttendanceImageCandidates(src);
    const [imageError, setImageError] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);
    const [rotation, setRotation] = useState(0);

    useEffect(() => {
      setImageError(false);
      setImageIndex(0);
      setRotation(0);
    }, [src]);

    if (!src || imageError) {
      return (
        <MDBox
          sx={{
            minHeight: height,
            width: "100%",
            borderRadius: "18px",
            border: `1px dashed ${ui.border}`,
            background: darkMode
              ? `linear-gradient(135deg, ${rgba(colors.info.main, 0.14)} 0%, ${rgba(colors.dark.main, 0.18)} 100%)`
              : `linear-gradient(135deg, ${rgba(colors.info.main, 0.08)} 0%, ${rgba(colors.primary.main, 0.05)} 100%)`,
            display: "grid",
            placeItems: "center",
            textAlign: "center",
            px: 2,
          }}
        >
          <MDBox>
            <PhotoCameraOutlined sx={{ color: colors.info.main, fontSize: 28, mb: 0.75 }} />
            <MDTypography variant="button" sx={{ color: ui.title, display: "block", fontWeight: 700 }}>
              Photo unavailable
            </MDTypography>
            <MDTypography variant="caption" color="text">
              The image URL may not be reachable.
            </MDTypography>
          </MDBox>
        </MDBox>
      );
    }

    return (
      <MDBox
        component="img"
        src={candidates[imageIndex]}
        alt={alt}
        onLoad={(event) => {
          const { naturalWidth, naturalHeight } = event.currentTarget;
          const shouldRotate = naturalWidth > naturalHeight;
          setRotation(shouldRotate ? -90 : 0);
        }}
        onError={() => {
          if (imageIndex < candidates.length - 1) {
            setImageIndex((prev) => prev + 1);
            return;
          }

          setImageError(true);
        }}
        sx={{
          width: "100%",
          height,
          //objectFit: "contain",
          objectFit: "cover",
          borderRadius: "18px",
          display: "block",
          backgroundColor: darkMode ? rgba(colors.white.main, 0.05) : colors.background.elevated,
          transform: rotation ? `rotate(${rotation}deg)` : "none",
          transformOrigin: "center",
        }}
      />
    );
  };

  const getAttendanceStatusMeta = (row) => {

		const durationHours = timeStringToHour(row?.data?.duration ?? "");

    if (durationHours > 0 && durationHours < 8.40) {
      return {
        label: row?.data?.leave ? "On Leave" : "Short Hours",
        tone:  row?.data?.leave?.status === "approved"
            ? "warning"
            : row?.data?.leave?.status === "pending"
            ? "info"
            : "error",
      };
    }

    if (row?.data?.holiday) {
      return {
        label: "Holiday",
        tone: "info",
      };
    }

    if (row?.data?.leave) {
      return {
        label: "On Leave",
        tone:
          row?.data?.leave?.status === "approved"
            ? "warning"
            : row?.data?.leave?.status === "pending"
            ? "info"
            : "error",
      };
    }

    if (row?.data?.wfh) {
      return {
        label: "WFH",
        tone: "info",
      };
    }
     if (durationHours >= 8.40) {
      return {
        label: "On-site",
        tone: "success",
      };
    }
  };

  const renderStatusChip = (row) => {
    const status = getAttendanceStatusMeta(row);
    const toneMap = {
      success: {
        background: rgba(colors.success.main, 0.12),
        color: colors.success.main,
      },
      warning: {
        background: rgba(colors.warning.main, 0.14),
        color: colors.warning.focus,
      },
      error: {
        background: rgba(colors.error.main, 0.12),
        color: colors.error.main,
      },
      info: {
        background: rgba(colors.info.main, 0.12),
        color: colors.info.focus,
      },
    };

    return (
      <MDBox
        sx={{
          display: "inline-flex",
          alignItems: "center",
          px: 1.25,
          py: 0.55,
          borderRadius: "999px",
          backgroundColor: toneMap[status?.tone]?.background,
          color: toneMap[status?.tone]?.color,
          fontSize: "0.75rem",
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        {status?.label}
      </MDBox>
    );
  };

  const handleView = (data, date) => {
    setInoutData(
      data.map((e) => ({
        id: e.id,
        type: e.type,
        in_time: moment(e.in_time, "hh:mm:ss").format("hh:mm A"),
        out_time: moment(e.out_time, "hh:mm:ss").format("hh:mm A"),
        duration: e.duration,
        date : date
      }))
    );
    setInoutDialog(true);
  };

  const handleSubmit = async () => {
    const [year, month] = selectedMonth.split("-");
    setIsFilterRefreshing(true);
    try {
      await Promise.all([
        fetchAttendanceLists(`?employee__id=${selectedEmp}&year=${year}&month=${month}`),
        fetchRemoteAttendanceByMonth(`?employee=${selectedEmp}&year=${year}&month=${parseInt(month, 10)}`),
      ]);
    } finally {
      window.setTimeout(() => setIsFilterRefreshing(false), 450);
    }
  };
  const [attendanceData, setAttendanceData] = useState({
    columns: [
      {
        Header: "DATE",
        accessor: "date",
        Cell: ({ row }) => (
          <MDBox display="flex" alignItems="center" gap={1.1}>
            <MDBox
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor:
                  getAttendanceStatusMeta(row?.original)?.tone === "success"
                    ? colors.success.main
                    : getAttendanceStatusMeta(row?.original)?.tone === "warning"
                    ? colors.warning.main
                    : getAttendanceStatusMeta(row?.original)?.tone === "error"
                    ? colors.error.main
                    : colors.info.main,
                flexShrink: 0,
              }}
            />
            <MDBox display="flex" flexDirection="column">
              <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700 }}>
                {row?.original?.date}
              </MDTypography>
              <MDTypography variant="caption" color="text">
                {days[new Date(row?.original?.date).getDay()]}
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
      },
      {
        Header: "EMPLOYEE",
        accessor: "employee",
        Cell: ({ row }) => (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700 }}>
              {row.original.employee.user.firstname} {row.original.employee.user.lastname}
            </MDTypography>
            <MDTypography variant="caption" color="text">
              {row.original.employee?.designation?.name || "Employee"}
            </MDTypography>
          </MDBox>
        ),
      },
      {
        Header: "CLOCK IN",
        accessor: "clock_in",
        Cell: ({ row }) =>
          row.original?.data?.holiday ? (
            <MDTypography variant="caption" color="text">
              Holiday
            </MDTypography>
          ) : row.original?.shift?.is_wfh ? (
            <MDTypography variant="caption" color="text">
              WFH
            </MDTypography>
          ) : (
            <MDTypography variant="button" color="text">
              {row?.original?.data?.in_time
                ? moment(row?.original?.data?.in_time, "hh:mm:ss").format("hh:mm A")
                : "-"}
            </MDTypography>
          ),
      },
      {
        Header: "CLOCK OUT",
        accessor: "clock_out",
        Cell: ({ row }) => (
          <MDTypography variant="button" color="text">
            {row?.original?.data?.out_time
              ? moment(row?.original?.data?.out_time, "hh:mm:ss").format("hh:mm A")
              : "-"}
          </MDTypography>
        ),
      },
      {
        Header: "BREAK",
        accessor: "break",
        Cell: ({ row }) => (
          <MDTypography variant="button" color="text">
            {row?.original?.data?.in_break || "-"}
          </MDTypography>
        ),
      },
      {
        Header: "DURATION",
        accessor: "duration",
        Cell: ({ row }) => (
          <MDBox display="flex" flexDirection="column">
						{row?.original?.data?.in_time ?  
            <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700 }}>
              {row?.original?.data?.duration || "-"}
            </MDTypography>
			      : null }
            {row?.original?.data?.leave?.number_of_hours && (
              <MDTypography variant="caption" sx={{ color: colors.error.main }}>
                Leave {row?.original?.data?.leave?.number_of_hours} Hours
              </MDTypography>
            )}
          </MDBox>
        ),
      },
      {
        Header: "STATUS",
        accessor: "status",
        Cell: ({ row }) => renderStatusChip(row.original),
      },
      {
        Header: "ACTION",
        accessor: "inout",
        Cell: ({ row }) => (
          <MDBox display="flex" alignItems="center" gap={0.25}>
            <Tooltip title="View Details">
              <IconButton
                aria-label="info"
                size="small"
                onClick={() => {
                  handleView(row.original.attendance_lists, row.original.date);
                }}
              >
                <InfoIcon />
              </IconButton>
            </Tooltip>
            {permissions.includes(modulePermissions.update_permission) &&
              parseInt(row?.original?.data?.duration?.split("Hrs")[0]) < 8 &&
              row?.original?.data?.leave == undefined && (
                <Tooltip title="Attendance Action">
                  <IconButton
                    aria-label="info"
                    size="small"
                    onClick={() => {
                      setEditAttendancePayload({
                        attendance_log: row?.original?.id,
                        type: "in",
                      });
                      setEditAttendanceDialogOpen(true);
                    }}
                  >
                    <CrisisAlert />
                  </IconButton>
                </Tooltip>
              )}
          </MDBox>
        ),
      },
    ],
    rows: [],
  });

		useEffect(() => {
	    fetchEmployee();
		},[selectedEmp])

		useEffect(() => {handleSubmit()},[selectedMonth,selectedEmp])

	const fetchEmployee = async () => {
		const res = await ApiCalls.getEmployee(selectedEmp);
		setActiveEmployee(res.data);
	}

  const fetchAttendanceLists = async (queryParams) => {
    const res = await ApiCalls.getAttendanceList(queryParams);
    if (res.success && res.code === 200) {
      attendanceData.rows = res.data.results;
			setData(res.data);
      setAttendanceData({ ...attendanceData });
    } else {
    }
  };
  const fetchRemoteAttendanceByMonth = async (queryParams) => {
    const res = await ApiCalls.getRemoteAttendanceByMonth(queryParams);

    if (res.success && res.code === 200) {
      setMobileAttendanceMeta(res.data || {});
      setMobileAttendanceRows(res.data?.attendance || []);
      setSelectedMobileDates([]);
    } else {
      setMobileAttendanceMeta({});
      setMobileAttendanceRows([]);
      setSelectedMobileDates([]);
    }
  };
  const toggleMobileDateSelection = (date) => {
    setSelectedMobileDates((current) =>
      current.includes(date) ? current.filter((item) => item !== date) : [...current, date]
    );
  };

  const approveMobileAttendanceDates = async (dates) => {
    if (!dates?.length) return;

    const employeeId = mobileAttendanceMeta?.employee_id || selectedEmp;
    const res = await ApiCalls.copyMobileAttendance(
      {
        employee: employeeId,
        dates,
      },
      false
    );

    if (res.success) {
      const [year, month] = selectedMonth.split("-");
      setMobileAttendanceDialogOpen(false);
      fetchRemoteAttendanceByMonth(`?employee=${employeeId}&year=${year}&month=${parseInt(month, 10)}`);
    }
  };
  async function handleSubmitAttendance() {
    var res = await ApiCalls.uploadAttendanceCorrection(
      { ...editAttendancePayload, org: loggedUser.org_id },
      false
    );

    if (res.success) {
      setEditAttendanceDialogOpen(false);
      handleSubmit();
    }
  }
  async function handleSubmitMisspunch() {
    var hasError = false ;
    if(missPunchDetailsPayload.comment == undefined || missPunchDetailsPayload.comment == "") {
   setMispunchCommentError("Comment is required");
   hasError = true ;
    } else {
      setMispunchCommentError("");
    }
    if(!hasError) {
      var res = await  ApiCalls.attendanceConsiderRequest({
        attendance_list: missPunchDetailsPayload.id,
        comment: missPunchDetailsPayload.comment
      },false);
      if(res.success ){

      }
      setMissPunchDetailsPayload({});
      setMissPunchDialogOpen(false);
    }
  }

  const filteredRows = useMemo(() => {
    if (!searchValue.trim()) {
      return activeLogTab === "machine" ? attendanceData.rows : mobileAttendanceRows;
    }
		const query = searchValue.toLowerCase();

    if (activeLogTab === "machine") {
      return attendanceData.rows.filter((row) => {
        const fullName = `${row?.employee?.user?.firstname || ""} ${row?.employee?.user?.lastname || ""}`.toLowerCase();
        return fullName.includes(query);
      });
    }

    return mobileAttendanceRows.filter((row) => {
      const fullName = `${mobileAttendanceMeta?.full_name || ""}`.toLowerCase();
      return (
        fullName.includes(query) ||
        `${row?.date || ""}`.toLowerCase().includes(query) ||
        `${row?.total_hours || ""}`.toLowerCase().includes(query)
      );
    });
	// }, [attendanceData.rows, searchValue]);

  }, [activeLogTab, attendanceData.rows, mobileAttendanceRows, mobileAttendanceMeta?.full_name, searchValue]);
  const filteredMobileDates = filteredRows.map((row) => row?.date).filter(Boolean);
  const allFilteredMobileSelected =
    filteredMobileDates.length > 0 &&
    filteredMobileDates.every((date) => selectedMobileDates.includes(date));
  const someFilteredMobileSelected =
    filteredMobileDates.some((date) => selectedMobileDates.includes(date)) &&
    !allFilteredMobileSelected;
  const handleToggleAllMobileDates = () => {
    if (!filteredMobileDates.length) return;

    if (allFilteredMobileSelected) {
      setSelectedMobileDates((current) => current.filter((date) => !filteredMobileDates.includes(date)));
      return;
    }

    setSelectedMobileDates((current) => [...new Set([...current, ...filteredMobileDates])]);
  };

  const machineAttendanceTable = useMemo(
    () => ({
      ...attendanceData,
      rows: filteredRows,
    }),
    [attendanceData, filteredRows]
  );

  const mobileAttendanceTable = useMemo(
    () => ({
      columns: [
       loggedUser.employee_id === activeEmployee?.hr_manager && {
          Header: () => (
            <Checkbox
              checked={allFilteredMobileSelected}
              indeterminate={someFilteredMobileSelected}
              onChange={handleToggleAllMobileDates}
            />
          ),
          accessor: "select",
          Cell: ({ row }) => (
            <Checkbox
              checked={selectedMobileDates.includes(row?.original?.date)}
              onChange={() => toggleMobileDateSelection(row?.original?.date)}
            />
          ),
        },
        {
          Header: "EMPLOYEE",
          accessor: "employee",
          Cell: ({row}) => (
            <MDBox display="flex" alignItems="center" gap={1.25}>
              <MDBox
              sx={{
                width: 56,
                height: 56,
                borderRadius: "16px",
                overflow: "hidden",
                border: `1px solid ${ui.border}`,
                backgroundColor: ui.card,
              }}
            >
              <MobileImagePreview
                src={row?.original?.photo}
                height={56}
								alt={(row?.original?.full_name || "E").charAt(0)}
              />
            </MDBox>
              <MDBox display="flex" flexDirection="column">
                <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700 }}>
                  {mobileAttendanceMeta?.full_name || "-"}
                </MDTypography>
                <MDTypography variant="caption" color="text">
                  Code {mobileAttendanceMeta?.employee_code || "-"}
                </MDTypography>
              </MDBox>
            </MDBox>
          ),
        },
        {
          Header: "DATE",
          accessor: "date",
          Cell: ({ row }) => (
            <MDBox display="flex" flexDirection="column">
              <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700 }}>
                {row?.original?.date}
              </MDTypography>
              <MDTypography variant="caption" color="text">
                {days[new Date(row?.original?.date).getDay()]}
              </MDTypography>
            </MDBox>
          ),
        },
        {
          Header: "CHECK IN",
          accessor: "checkin_time",
          Cell: ({ row }) => (
            <MDTypography variant="button" color="text">
              {row?.original?.checkin_time ? moment(row?.original?.checkin_time).format("hh:mm A") : "-"}
            </MDTypography>
          ),
        },
        {
          Header: "CHECK OUT",
          accessor: "checkout_time",
          Cell: ({ row }) => (
            <MDTypography variant="button" color="text">
              {row?.original?.checkout_time ? moment(row?.original?.checkout_time).format("hh:mm A") : "-"}
            </MDTypography>
          ),
        },
        {
          Header: "BREAK",
          accessor: "break_duration",
          Cell: ({ row }) => (
            <MDTypography variant="button" color="text">
              {row?.original?.break_duration || "-"}
            </MDTypography>
          ),
        },
        {
          Header: "HOURS",
          accessor: "total_hours",
          Cell: ({ row }) => (
            <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700 }}>
              {row?.original?.total_hours || "-"}
            </MDTypography>
          ),
        },
        {
          Header: "RECORDS",
          accessor: "records",
          Cell: ({ row }) => (
            <MDBox
              sx={{
                px: 1.2,
                py: 0.65,
                borderRadius: "999px",
                display: "inline-flex",
                backgroundColor: rgba(colors.info.main, 0.1),
                color: colors.info.main,
                fontWeight: 700,
                fontSize: "0.75rem",
              }}
            >
              {row?.original?.records?.length || 0} logs
            </MDBox>
          ),
        },
        {
          Header: "ACTION",
          accessor: "action",
          Cell: ({ row }) => (
            <Tooltip title="View mobile log details">
              <IconButton
                aria-label="view mobile log details"
                size="small"
                sx={{
                  backgroundColor: rgba(colors.info.main, 0.1),
                  color: colors.info.main,
                  "&:hover": {
                    backgroundColor: rgba(colors.info.main, 0.18),
                  },
                }}
                onClick={() => {
                  setMobileAttendanceDetail(row.original);
                  setMobileAttendanceDialogOpen(true);
                }}
              >
                <InfoIcon />
              </IconButton>
            </Tooltip>
          ),
        },
      ].filter(Boolean),
      rows: filteredRows,
    }),
    [
      allFilteredMobileSelected,
      filteredRows,
      handleToggleAllMobileDates,
      mobileAttendanceMeta?.employee_code,
      mobileAttendanceMeta?.full_name,
      selectedMobileDates,
      someFilteredMobileSelected,
      ui.border,
      ui.card,
      ui.title,
    ]
  );

  const attendanceStats = useMemo(() => {
    if (activeLogTab === "mobile") {
      const rows = mobileAttendanceRows || [];

      return rows.reduce(
        (acc, row) => {
          acc.totalDays = rows.length;
          acc.present += row?.checkin_time ? 1 : 0;
          acc.wfh += 1;
          acc.breaks += row?.break_duration && row?.break_duration !== "00:00" ? 1 : 0;
          return acc;
        },
        { totalDays: 0, present: 0, holiday: 0, wfh: 0, leave: 0, breaks: 0 }
      );
    }

    const rows = attendanceData.rows || [];

    return rows.reduce(
      (acc, row) => {
				acc.totalDays = rows.length ? rows.length : 0 ;
				acc.present = row?.data?.in_time || row?.data?.wfh ? acc.present += 1 : acc.present;
				acc.holiday = row?.data?.holiday ? acc.holiday += 1 : acc.holiday;
				acc.wfh = row.data.wfh ? acc.wfh +=1 : acc.wfh;
				acc.leave = row?.data?.leave || row.data.nodata ? acc.leave += 1 : acc.leave;
        return acc;
      },
      { totalDays: 0, present: 0, holiday: 0, wfh: 0, leave: 0, breaks: 0 }
    );
  }, [activeLogTab, attendanceData.rows, mobileAttendanceRows]);
	// }, [attendanceData.rows]);

  const statCards = 
	[
    {
      label: "Total Days",
      value: attendanceStats.totalDays,
      meta: "This month",
      icon: <TimerOutlined sx={{ color: colors.info.main, fontSize: 20 }} />,
      surface: rgba(colors.info.light, 0.3),
    },
    {
      label: "Present",
      value: attendanceStats.present,
      meta: "Days",
      icon: <CheckCircleOutline sx={{ color: colors.success.main, fontSize: 20 }} />,
      surface: rgba(colors.success.main, 0.08),
    },
		activeLogTab !== "mobile" && {
			label: "WFH",
      value: attendanceStats.wfh,
      meta: "Days",
      icon: <HomeWork sx={{ color: colors.success.main, fontSize: 20 }} />,
      surface: rgba(colors.success.main, 0.08),
		},
    activeLogTab === "mobile" && {
      label: "Mobile Days",
      value: attendanceStats.totalDays,
      meta: "This month",
      icon: <TimerOutlined sx={{ color: colors.info.main, fontSize: 20 }} />,
      surface: rgba(colors.info.light, 0.3),
    },
    {
      label: "Holidays",
      value: attendanceStats.holiday,
      meta: "Days",
      icon: <QueryBuilderRounded sx={{ color: colors.warning.focus, fontSize: 20 }} />,
      surface: rgba(colors.warning.main, 0.08),
    },
    {
      label: "On Leave",
      value: attendanceStats.leave,
      meta: "days",
      icon: <WorkOff/>,
      surface: rgba(colors.error.main, 0.08),
    },
  ];

  const exportAttendanceReport = () => {
    const rows = 
		activeLogTab === "mobile"
      ? filteredRows.map((row) => ({
          Date: row?.date,
          Employee: mobileAttendanceMeta?.full_name || "",
          CheckIn: row?.checkin_time ? moment(row?.checkin_time).format("hh:mm A") : "",
          CheckOut: row?.checkout_time ? moment(row?.checkout_time).format("hh:mm A") : "",
          Break: row?.break_duration || "",
          TotalHours: row?.total_hours || "",
          Records: row?.records?.length || 0,
        }))
      : 
			filteredRows.map((row) => ({
          Date: row?.date,
          Employee: `${row?.employee?.user?.firstname || ""} ${row?.employee?.user?.lastname || ""}`.trim(),
          ClockIn: row?.data?.in_time
            ? moment(row?.data?.in_time, "hh:mm:ss").format("hh:mm A")
            : "",
          ClockOut: row?.data?.out_time
            ? moment(row?.data?.out_time, "hh:mm:ss").format("hh:mm A")
            : "",
          Break: row?.data?.in_break || "",
          Duration: row?.data?.duration || "",
          Status: getAttendanceStatusMeta(row).label,
        }));

    const csv = [
      Object.keys(rows[0] || {}).join(","),
      ...rows.map((row) => Object.values(row).map((value) => `"${value ?? ""}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${activeLogTab}-attendance-report-${selectedMonth || moment().format("YYYY-MM")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
	

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox p={3} sx={{ backgroundColor: ui.page }}>
        <MDBox mb={3}>
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item xs={12} md={8} sx={{display : "flex", gap : 2, alignItems : "center"}}>
							<MDBox
								sx={{
									width: 48,
									height: 48,
									borderRadius: "16px",
									display: "grid",
									placeItems: "center",
									background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
									color: colors.white.main,
								}}
							>
								<FingerprintSharp />
							</MDBox>
							<MDBox sx={{ display: "flex", flexDirection: "column" }}>
								<MDTypography
									variant="h3"
									sx={{ color: ui.title, letterSpacing: "-0.03em" }}
								>
									Attendance Management
								</MDTypography>
								<MDTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
									Monitor and track employee attendance records.
								</MDTypography>
							</MDBox>
            </Grid>
            <Grid item xs={12} md="auto">
              <MDButton
                color="info"
                startIcon={<DownloadRounded />}
                onClick={exportAttendanceReport}
                sx={{ borderRadius: "14px", px: 2.5 }}
              >
                Export Report
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>

        <Grid container spacing={2.5} mb={3}>
          {statCards.map((card) => (
						<>
						{
							card && (
								<Grid item xs={12} sm={6} xl={2.4} key={card.label}>
              <Card
                sx={{
                  p: 2.25,
                  borderRadius: "24px",
                  border: `1px solid ${ui.border}`,
                  boxShadow: darkMode
                    ? `0 18px 36px ${rgba(colors.black.main, 0.28)}`
                    : `0 14px 32px ${rgba(colors.dark.main, 0.05)}`,
									background: ui.statCard,
                }}
              >
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                  <MDBox>
                    <MDTypography
                      variant="caption"
                      sx={{
                        color: colors.info.light,
                        color: ui.body,
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        fontWeight: 800,
                      }}
                    >
                      {card.label}
                    </MDTypography>
                    <MDTypography variant="h3" sx={{ color: ui.title, mt: 1 }}>
                      {card.value}
                    </MDTypography>
                    <MDTypography variant="caption" sx={{ mt: 0.65, display: "block", color: ui.body }}>
                      {card.meta}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "14px",
                      backgroundColor: ui.iconSurface,
                      display: "grid",
                      placeItems: "center",
                    }}
                  >
                    {card.icon}
                  </MDBox>
                </Stack>
              </Card>
            </Grid>
							)
						}
						</>
          ))}
        </Grid>

        <Card
          sx={{
            mb: 3,
            boxShadow: darkMode
              ? `0 16px 38px ${rgba(colors.black.main, 0.28)}`
              : `0 16px 38px ${rgba(colors.dark.main, 0.05)}`,
            overflow: "visible",
						background: ui.soft,
          }}
        >
          <MDBox px={3} py={2.25} borderBottom={`1px solid ${rgba(colors.secondary.main, 0.08)}`}>
            <MDTypography variant="h6">
              Search & Filter
            </MDTypography>
          </MDBox>

          <MDBox p={3}>
						<MDBox display="flex" justifyContent="space-between">
							<Grid container spacing={1} alignItems="center">
              <Grid item xs={12} md={4}>
                <SelectHierarchicalEmployee
                  label="Select Employee"
									fullWidth = {true}
	                  defaultValue={loggedUser.employee_id}
	                  onSelected={(e) => {
	                    setSelectedEmp(e ?? loggedUser.employee_id);
	                  }}
	                />
              </Grid>
							<Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  size="medium"
                  id="month"
                  type="month"
                  value={selectedMonth}
                  name="Date"
                  label="Month"
                  onChange={(event) => {
                    setSelectedMonth(event.target.value);
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
							<Grid item xs={12} md={4}>
               {/*<MDButton
                 fullWidth
                 color="info"
                 onClick={handleSubmit}
                 startIcon={
                   <Refresh
                     className="filter-refresh-icon"
                     sx={{
                       transition: "transform 0.45s ease",
                       transform: isFilterRefreshing ? "rotate(360deg)" : "rotate(0deg)",
                     }}
                   />
                 }
                 sx={{
                   minHeight: 44,
                   borderRadius: "14px",
                   "&:hover .filter-refresh-icon": {
                     transform: "rotate(180deg)",
                   },
                 }}
               >
                 Apply Filters
               </MDButton>*/}
              </Grid>
            </Grid>
						</MDBox>
            <MDBox
              mt={3}
              sx={{
                p: 0.75,
                borderRadius: "18px",
                display: "inline-flex",
                backgroundColor: ui.card,
                border: `1px solid ${ui.border}`,
								width: "100%",
              }}
            >
              <Tabs
                value={activeLogTab}
                onChange={(event, value) => setActiveLogTab(value)}
                sx={{
                  minHeight: 0,
                  "& .MuiTabs-indicator": { display: "none" },
                  "& .MuiTab-root": {
                    minHeight: 40,
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: 700,
                    color: ui.body,
                  },
                  "& .Mui-selected": {
                    color: `${colors.white.main} !important`,
                    background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
                  },
									width: "100%"
                }}
              >
                <Tab fullWidth value="machine" label="Machine Logs" />
                <Tab value="mobile" label="Mobile Logs" />
              </Tabs>
            </MDBox>
          </MDBox>
        </Card>

        {activeLogTab === "mobile" && (
          <MDBox
            mb={2}
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            gap={1.25}
          >
            <MDTypography variant="button" color="text">
              {selectedMobileDates.length
                ? `${selectedMobileDates.length} mobile log day(s) selected`
                : "Select one or more mobile log days to approve"}
            </MDTypography>
           {loggedUser.employee_id === activeEmployee?.hr_manager && <MDButton
              color="success"
              startIcon={<CheckCircleRounded />}
              disabled={!selectedMobileDates.length}
              onClick={() => approveMobileAttendanceDates(selectedMobileDates)}
              sx={{ borderRadius: "14px", px: 2.5 }}
            >
              Approve Selected
            </MDButton>}
          </MDBox>
        )}

          <DataTable
            table={activeLogTab === "machine" ? machineAttendanceTable : mobileAttendanceTable}
            entriesPerPage={{
              defaultValue: 30,
              entries: [5, 10, 15, 20, 25, 30],
            }}
            showTotalEntries={false}
            isSorted={false}
          />

          <MDBox
            px={3}
            py={2}
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "center" }}
            gap={1.5}
            borderTop={`1px solid ${ui.border}`}
          >
            <MDTypography variant="button" color="text">
              {activeLogTab === "machine"
                ? `Total scheduled hours: ${data?.summary?.total_expected_hours || "-"}`
                : `Employee: ${mobileAttendanceMeta?.full_name || "-"} (${mobileAttendanceMeta?.employee_code || "-"})`}
            </MDTypography>
            <MDTypography variant="button" color="text">
              {activeLogTab === "machine"
                ? `Worked duration: ${data?.summary?.total_payable_hours || "-"}`
                : `Remote attendance days: ${mobileAttendanceMeta?.total_days || 0}`}
            </MDTypography>
          </MDBox>
        {/*</Card>*/}
      </MDBox>
      <Dialog
        PaperProps={{
          style: {
            backgroundColor: ui.card,
            boxShadow: "none",
            width: "auto",
            maxWidth: "none",
            borderRadius: "10px",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
        open={inoutDialogOpen}
        onClose={() => setInoutDialog(false)}
      >
        <DialogTitle
          style={{
            width: "100%",
            padding: "20px",
            borderBottom: "10px solid ",
            backgroundColor: colors.info.main,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            In/Out Details
          </Typography>
        </DialogTitle>
        <DialogContent
          style={{
            padding: "4px",
          }}
        >
          <MDBox align="center" p={2}>
            <SalesTable
              title=""
              rows={inOutData}
              action={{
                action: [
                  {
                    icon: <PunchClock />,
                    key: "edit",
                    idKey: "id",
                    presenseKey: ["mis_punch", "out"],
                    presenseTypeKey: "type",
                  },
                ],
              }}
              onActionClick={(v) => {
                if (v.action == "edit") {
                  setInoutDialog(false);
                  setMissPunchDialogOpen(true);
                  setMissPunchDetailsPayload((state) => ({
                    ...state,
                    id: v.id,
                  }));
                }
              }}
              ignore={["id"]}
            />
          </MDBox>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: ui.dialogPaper,
            boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
            width: "min(980px, calc(100vw - 32px))",
						height:"70%",
            maxWidth: "none",
            borderRadius: "24px",
            border: `1px solid ${ui.border}`,
          },
        }}
        open={mobileAttendanceDialogOpen}
        onClose={() => setMobileAttendanceDialogOpen(false)}
      >
        <DialogContent
          sx={{
            p: 0,
            background: darkMode
              ? `linear-gradient(180deg, ${palette.background.card} 0%, ${palette.background.muted} 100%)`
              : `linear-gradient(180deg, ${colors.white.main} 0%, ${colors.background.accent} 100%)`,
          }}
        >
          {mobileAttendanceDetail && (
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <MDBox
                  sx={{
                    p: { xs: 2.5, md: 3 },
                    background: darkMode
                      ? `linear-gradient(135deg, ${rgba(colors.primary.main, 0.24)} 0%, ${rgba(colors.info.main, 0.12)} 100%)`
                      : `linear-gradient(135deg, ${rgba(colors.primary.main, 0.1)} 0%, ${rgba(colors.info.main, 0.12)} 100%)`,
                    borderBottom: `1px solid ${ui.border}`,
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <MDTypography variant="h4" sx={{ color: ui.title, letterSpacing: "-0.03em" }}>
                        {mobileAttendanceMeta?.full_name || "Employee"} remote log
                      </MDTypography>
                      <MDTypography variant="body2" color="text" sx={{ mt: 0.5 }}>
                        {mobileAttendanceDetail?.date || "-"} • {mobileAttendanceDetail?.records?.length || 0} tracked records
                      </MDTypography>
                    </Grid>
										<Grid item xs={12} md={6}>
											<Stack direction="row" spacing={1.5} justifyContent='flex-end'>
												{loggedUser.employee_id === data?.results[0]?.employee?.hr_manager && <MDButton
													color="success"
													startIcon={<CheckCircleRounded />}
													onClick={() => approveMobileAttendanceDates([mobileAttendanceDetail?.date])}
													sx={{ borderRadius: "14px", px: 2.25 }}
												>
													Approve This Log
												</MDButton>}
												<MDBox sx={{ px: 1.5, py: 1, borderRadius: "14px", backgroundColor: ui.card }}>
													<MDTypography variant="caption" color="text">Hours</MDTypography>
													<MDTypography variant="button" sx={{ color: ui.title, display: "block", fontWeight: 700 }}>
														{mobileAttendanceDetail?.total_hours || "-"}
													</MDTypography>
												</MDBox>
												<MDBox sx={{ px: 1.5, py: 1, borderRadius: "14px", backgroundColor: ui.card }}>
													<MDTypography variant="caption" color="text">Break</MDTypography>
													<MDTypography variant="button" sx={{ color: ui.title, display: "block", fontWeight: 700 }}>
														{mobileAttendanceDetail?.break_duration || "-"}
													</MDTypography>
												</MDBox>
											</Stack>
										</Grid>
                  </Grid>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={4}>
                <MDBox sx={{ p: 2.5 }}>
                  <Card
                    sx={{
                      p: 2.25,
                      borderRadius: "24px",
                      boxShadow: "none",
                      border: `1px solid ${ui.border}`,
                      backgroundColor: ui.card,
                    }}
                  >
                    <MDTypography variant="h6" sx={{ color: ui.title, mb: 1.5 }}>
                      Day Summary
                    </MDTypography>
                    <Stack spacing={1.25}>
                      <MDBox sx={{ p: 1.25, borderRadius: "16px", backgroundColor: ui.soft }}>
                        <MDTypography variant="caption" color="text">Check in</MDTypography>
                        <MDTypography variant="button" sx={{ color: ui.title, display: "block", fontWeight: 700 }}>
                          {mobileAttendanceDetail?.checkin_time ? moment(mobileAttendanceDetail?.checkin_time).format("DD MMM YYYY, hh:mm A") : "-"}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ p: 1.25, borderRadius: "16px", backgroundColor: ui.soft }}>
                        <MDTypography variant="caption" color="text">Check out</MDTypography>
                        <MDTypography variant="button" sx={{ color: ui.title, display: "block", fontWeight: 700 }}>
                          {mobileAttendanceDetail?.checkout_time ? moment(mobileAttendanceDetail?.checkout_time).format("DD MMM YYYY, hh:mm A") : "-"}
                        </MDTypography>
                      </MDBox>
                      <MDBox sx={{ p: 1.25, borderRadius: "16px", backgroundColor: ui.soft }}>
                        <MDTypography variant="caption" color="text">Primary location</MDTypography>
                        <MDTypography variant="button" sx={{ color: ui.title, display: "block", fontWeight: 700 }}>
                          {mobileAttendanceDetail?.location?.latitude || "-"}, {mobileAttendanceDetail?.location?.longitude || "-"}
                        </MDTypography>
                        <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 0.35 }}>
                          IP: {mobileAttendanceDetail?.location?.ip || "-"}
                        </MDTypography>
                      </MDBox>
                    </Stack>
                    <MDBox mt={2}>
                      <MDTypography variant="caption" sx={{ color: ui.body, display: "block", mb: 1 }}>
                        Featured photo
                      </MDTypography>
                      <MDBox
                        sx={{
                          height: 240,
                          borderRadius: "18px",
                          overflow: "hidden",
                          border: `1px solid ${ui.border}`,
                          backgroundColor: ui.soft,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          p: 1,
                        }}
                      >
                        <MobileImagePreview
                          src={mobileAttendanceDetail?.photo}
                          alt="Mobile attendance"
                          height={240}
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={8}>
                <MDBox sx={{ p: 2.5, pl: { md: 0 }, height: "100%" }}>
                  <Card sx={{ p: 2.25, borderRadius: "24px", boxShadow: "none", border: `1px solid ${ui.border}`, height:"100%" }}>
                  <MDTypography variant="h6" sx={{ color: ui.title, mb: 1.5 }}>
                    Punch Records
                  </MDTypography>
                  <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 1.5 }}>
                    Scroll horizontally to explore all punch records.
                  </MDTypography>
                  <MDBox
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      overflowX: "auto",
                      overflowY: "hidden",
                      pb: 1,
                      scrollSnapType: "x proximity",
                      "&::-webkit-scrollbar": {
                        height: 8,
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: darkMode ? rgba(colors.white.main, 0.06) : rgba(colors.dark.main, 0.05),
                        borderRadius: "999px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: rgba(colors.info.main, 0.45),
                        borderRadius: "999px",
                      },
											height: "100%",
                    }}
                  >
                    {(mobileAttendanceDetail?.records || []).map((record, index) => (
                      <MDBox
                        key={record?.id || index}
                        sx={{
													height: "100%",
                          minWidth: { xs: "100%", sm: 340, md: 360 },
                          maxWidth: { xs: "100%", sm: 340, md: 360 },
                          flexShrink: 0,
                          scrollSnapAlign: "start",
                          p: 1.5,
                          borderRadius: "18px",
                          border: `1px solid ${ui.border}`,
                          backgroundColor: ui.card,
                          boxShadow: darkMode
                            ? `0 16px 32px ${rgba(colors.black.main, 0.18)}`
                            : `0 14px 28px ${rgba(colors.dark.main, 0.05)}`,
                        }}
                      >
                        <Grid container spacing={1.5} alignItems="center">
                          <Grid item xs={12}>
                            <Stack direction="row" spacing={1.25} alignItems="center">
                              <MDBox
                                sx={{
                                  width: 62,
                                  height: 62,
                                  borderRadius: "18px",
                                  overflow: "hidden",
                                  border: `1px solid ${ui.border}`,
                                  flexShrink: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: ui.soft,
                                }}
                              >
                                <MobileImagePreview
                                  src={record?.photo || mobileAttendanceDetail?.photo}
                                  alt={`${record?.action || "record"} thumbnail`}
                                  height={62}
                                />
                              </MDBox>
                              <MDBox>
                                <MDTypography variant="button" sx={{ color: ui.title, fontWeight: 700, textTransform: "capitalize" }}>
                                  {(record?.action || "-").replaceAll("_", " ")}
                                </MDTypography>
                                <MDTypography variant="caption" color="text" sx={{ display: "block" }}>
                                  {record?.occurred_at ? moment(record?.occurred_at).format("DD MMM YYYY, hh:mm:ss A") : "-"}
                                </MDTypography>
                                <MDTypography variant="caption" color="text" sx={{ display: "block", textTransform: "capitalize" }}>
                                  Type: {record?.type || "-"} | Status: {record?.status || "-"}
                                </MDTypography>
                              </MDBox>
                            </Stack>
                          </Grid>
                          <Grid item xs={12}>
                            <Stack spacing={0.75}>
                              <MDBox display="flex" alignItems="center" gap={0.75}>
                                <AccessTimeRounded sx={{ fontSize: 16, color: colors.info.main }} />
                                <MDTypography variant="caption" color="text">
                                  {record?.time || "-"}
                                </MDTypography>
                              </MDBox>
                              <MDBox display="flex" alignItems="center" gap={0.75}>
                                <FmdGoodOutlined sx={{ fontSize: 16, color: colors.info.main }} />
                                <MDTypography variant="caption" color="text">
                                  {record?.location?.latitude || "-"}, {record?.location?.longitude || "-"}
                                </MDTypography>
                              </MDBox>
                              <MDTypography variant="caption" color="text" sx={{ display: "block" }}>
                                IP: {record?.location?.ip || "-"}
                              </MDTypography>
                            </Stack>
                          </Grid>
                          {record?.photo ? (
                            <Grid item xs={12}>
                              <Divider sx={{ my: 1 }} />
                              <Grid container spacing={1.25}>
                                <Grid item xs={12} height={220}>
                                  <MDBox
                                    sx={{
                                      height: 300,
                                      borderRadius: "18px",
                                      overflow: "hidden",
                                      border: `1px solid ${ui.border}`,
                                      backgroundColor: ui.soft,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      p: 1,
                                    }}
                                  >
                                    <MobileImagePreview
                                      src={record.photo}
                                      alt={`${record?.action || "record"} evidence`}
                                      height={250}
                                    />
                                  </MDBox>
                                </Grid>
                              </Grid>
                            </Grid>
                          ) : null}
                        </Grid>
                      </MDBox>
                    ))}
                  </MDBox>
                </Card>
                </MDBox>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: ui.dialogPaper,
            boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
            // height: "500px",
            // width: "500px",
            maxWidth: "none",
            borderRadius: "20px",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            border: `1px solid ${ui.border}`,
          },
        }}
        open={missPunchDialogOpen}
        onClose={() => {
          setMissPunchDialogOpen(false);
        }}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            MissPunch Details
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
						background : darkMode
              ? `linear-gradient(180deg, ${palette.background.card} 0%, ${palette.background.muted} 100%)`
              : `linear-gradient(180deg, ${colors.light.main} 0%, ${colors.background.accent} 100%)`
          }}
        >
          <MDBox align="end" p={2}>
            <TextField
              label="Add Comment"
              required
              fullWidth
              onChange={(e) => {
                setMissPunchDetailsPayload((state) => ({
                  ...state,
                  comment: e.target.value,
                }));
              }}
              error={!!mispunchCommentError}
              helperText={mispunchCommentError}
              style={{ paddingRight: "10px", paddingBottom: "10px" }}
            />
            <MDButton color="info" onClick={() => {
handleSubmitMisspunch()
            }}>
              Submit
            </MDButton>
          </MDBox>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: ui.dialogPaper,
            boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
            maxWidth: "none",
            borderRadius: "20px",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            border: `1px solid ${ui.border}`,
          },
        }}
        open={editAttendanceDialogOpen}
        onClose={() => setEditAttendanceDialogOpen(false)}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            Edit Attendance Details
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
            backgroundColor: ui.dialogBody,
          }}
        >
          <MDBox align="center" p={2}>
            <Grid container spacing={1} alignItems={"flex-end"}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={[
                    { value: "5 mins", duration: "00:05:00" },
                    { value: "10 mins", duration: "00:10:00" },
                    { value: "20 mins", duration: "00:20:00" },
                    { value: "30 mins", duration: "00:30:00" },
                  ]}
                  getOptionLabel={(v) => v.value}
                  onChange={(event, values) => {
                    let [hour, minute] = values?.duration?.split(":");
                    setEditAttendancePayload((state) => ({
                      ...state,
                      duration: values?.duration,
                      out_time: moment(editAttendancePayload?.in_time, "HH:mm")
                        .add(hour, "hours")
                        .add(minute, "minutes")
                        .format("HH:mm"),
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Time Difference" />
                  )}
                ></Autocomplete>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      label="Start Time"
                      fullWidth
                      inputProps={{ type: "time" }}
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        let [hour, minute] =
                          editAttendancePayload?.duration?.split(":") ?? [
                            "0",
                            "0",
                          ];
                        setEditAttendancePayload((state) => ({
                          ...state,
                          in_time: e.target.value,
                          out_time: moment(e.target.value, "HH:mm")
                            .add(hour, "hours")
                            .add(minute, "minutes")
                            .format("HH:mm"),
                        }));
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      label="End Time"
                      value={editAttendancePayload?.out_time}
                      fullWidth
                      inputProps={{ type: "time", readOnly: true }}
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {}}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  variant="standard"
                  label="Note"
                  fullWidth
                  placeholder="Attendance Correction Note"
                  // value={leaveRequestPayload.reason}
                  onChange={(e) => {
                    setEditAttendancePayload((state) => ({
                      ...state,
                      comment: e.target.value,
                    }));
                    //   isCreateEmployee ? setEmail(e.target.value) : null;
                    //   setEmployee({ ...Employee, email: e.target.value });
                  }}
                  required
                />
              </Grid>
            </Grid>
            <MDBox p={2} align="center">
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => handleSubmitAttendance()}
              >
                Submit
              </MDButton>
            </MDBox>
          </MDBox>
        </DialogContent>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: ui.dialogPaper,
            boxShadow: darkMode ? "0 24px 48px rgba(2, 6, 23, 0.42)" : "none",
            width: "500px",
            height: "auto",
            maxWidth: "none",
            borderRadius: "20px",
            border: `1px solid ${ui.border}`,
          },
        }}
        open={statusDialogOpen}
        onClose={() => setStatusDialog(false)}
      >
        <DialogTitle
          sx={{
            width: "100%",
            p: "20px",
            background: `linear-gradient(135deg, ${colors.info.main} 0%, ${colors.info.focus} 100%)`,
            color: "white",
          }}
        >
          <Typography sx={{ color: "white", fontWeight: "Medium" }}>
            Add Status
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            p: "4px",
            backgroundColor: ui.dialogBody,
          }}
        >
          <MDBox>
            <MDBox py={3} px={2}>
              <TextField
                fullWidth
                id="outlined-multiline-flexible"
                label="What you have done today?"
                multiline
                maxRows={4}
                rows={10}
              />
            </MDBox>
            <MDBox pb={3} px={2}>
              <TextField
                fullWidth
                id="outlined-multiline-flexible"
                label="Any blockers?"
                multiline
                rows={3}
              />
            </MDBox>
            <MDBox align="end" px={3} pb={1}>
              <MDButton
                variant="gradient"
                color="info"
                size="large"
                fullWidth
                onClick={() => {}}
              >
                Submit
              </MDButton>
            </MDBox>
          </MDBox>
        </DialogContent>
      </Dialog>

    </DashboardLayout>
  );
}
export default Attendance;
